type HandleErrorParams = {
  response?: {
    data?: {
      errors?: string[],
    },
  },
}

export const handleError = (params: HandleErrorParams = {}) => {
  const { response } = params
  return response?.data?.errors || ['Something went wrong']
}

export default handleError
